import { createRecipe } from './runtime.js';

const fieldGroupConfig = {"name":"fieldGroup","defaultVariants":{"size":"lg"},"variantMap":{"size":["lg","md","sm"]}}

export const fieldGroup = /* @__PURE__ */ createRecipe(fieldGroupConfig)